"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormSettings = void 0;

var getFormSettings = function getFormSettings(state) {
  return state.modules.marketing['form'].entities.formSettings;
};

exports.getFormSettings = getFormSettings;